import { ChartProps } from 'react-chartjs-2';

import currentTheme from '~config/theme';

export const getChartProps = (
  totalCompletedtems: number,
  totalWithoutIssuesItems: number,
  totalWithIssuesItems: number,
): ChartProps<'doughnut', number[], string> => {
  const data =
    totalCompletedtems > 0
      ? [totalWithoutIssuesItems, totalWithIssuesItems]
      : [1, 0];

  return {
    type: 'doughnut',
    data: {
      datasets: [
        {
          data: data,
          backgroundColor: [
            currentTheme.palette.success.light,
            currentTheme.palette.error.light,
          ],
          borderWidth: 0,
          hoverOffset: 0,
        },
      ],
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      },
      cutout: '60%',
      events: [],
    },
    height: 80,
    width: 80,
  };
};
